import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import analytics from '@stone/utils/analytics';
import ProductBoutiqueModal from './ProductBoutiqueModal';
import Button from '@stone/ui/button/Button';
const ProductActionReserveInBoutique = (props) => {
    const { t } = useTranslation();
    const [showOverlay, setShowOverlay] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", cls: [`button--${props.buttonType}`], onClick: () => {
                setShowOverlay(true);
                analytics.productActionIntent('reserve in store', props.color.productId || props.product.id);
            }, ariaHaspopup: "dialog" },
            React.createElement("span", null, props.overrideLabel || t('product.reserveinboutique'))),
        props.product && (React.createElement(ProductBoutiqueModal, { isOpen: showOverlay, title: props.overrideLabel || t('product.reserveinboutique'), mode: "reserve", product: props.product, size: props.size, color: props.color, colourVariations: props.colourVariations, sizeVariations: props.sizeVariations, onRequestClose: () => setShowOverlay(false), setSizeGuideOpen: props === null || props === void 0 ? void 0 : props.setSizeGuideOpen }))));
};
ProductActionReserveInBoutique.defaultProps = {
    buttonType: 'tertiary',
};
export default ProductActionReserveInBoutique;
